import { Typography } from '@musinsa/mds';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { twMerge } from 'tailwind-merge';
import { curatorQueries } from '../../query-factory';

interface Props {
  className?: string;
}

export const NicknameQuotaIndicator = React.memo(({ className }: Props) => {
  const {
    data: countData,
    isPending,
    isError,
  } = useQuery({ ...curatorQueries.profile.nicknameAvailableCount });

  // TODO : 로딩 시 UI 문의 후 구현해야 함
  if (isPending) {
    return (
      <div className={twMerge('', className)}>
        <Typography variant="body14pxMed">이번 달 수정 가능 횟수</Typography>
      </div>
    );
  }

  // TODO : 에러 시 UI 문의 후 구현해야 함
  if (isError || !countData) {
    return (
      <div className={twMerge('', className)}>
        <Typography variant="body14pxMed">이번 달 수정 가능 횟수</Typography>
      </div>
    );
  }

  const { remainingCount, maxCount } = countData;

  return (
    <div className={twMerge('', className)}>
      <Typography variant="body14pxMed">{`이번 달 수정 가능 횟수(${remainingCount}/${maxCount}회)`}</Typography>
    </div>
  );
});
